export const initialState = {
  members: [],
};

export function FETCH_MEMBERS_NORMALIZATION(nextState, { result }) {
  nextState.members = result;
}
